import * as types from './mutation-types';

export default {

  /**
   * Altera o contexto da interface do painel.
   *
   * @param state
   * @param json
   */
  [types.UPDATE_STATE](state, data) {
    state.items = data;
  },

  [types.UPDATE_NAME](state, e) {
    state.name = e.target.value;
  },

  [types.UPDATE_EMAIL](state, e) {
    state.email = e.target.value;
  },

  [types.UPDATE_PHONE](state, e) {
    state.phone = e.target.value;
  },

  [types.UPDATE_NOTE](state, e) {
    state.note = e.target.value;
  },

};
